<template>
  <div>
    <Head :title="__(title)" />
    <div class="max-w-2xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">

          <!-- Numéro de téléphone -->
          <div class="pb-8 pr-6 w-full">
            <label class="form-label">Numéro de téléphone <span class="text-red-500">*</span></label>
            <input
              v-model="form.phone_number"
              type="tel"
              placeholder="+2290196XXXXXX"
              class="form-input"
              :class="{ 'border-red-500': errors.phone_number }"
              required
            />
            <div v-if="errors.phone_number" class="form-error">{{ errors.phone_number }}</div>
            <p class="text-xs text-gray-500 mt-1">Format international E.164 (ex: +2290196123456)</p>
          </div>

          <!-- Nom et prénom -->
          <div class="pb-8 pr-6 w-full">
            <label class="form-label">Nom et prénom</label>
            <input v-model="form.label" type="text" class="form-input" placeholder="Ex: Kokou Agbossou" />
            <div v-if="errors.label" class="form-error">{{ errors.label }}</div>
          </div>

          <!-- Institution -->
          <div class="pb-8 pr-6 w-full">
            <label class="form-label">Institution associée</label>
            <select v-model="form.department_id" class="form-input">
              <option :value="null">— Aucune —</option>
              <option v-for="dept in departments" :key="dept.id" :value="dept.id">{{ dept.name }}</option>
            </select>
          </div>

          <!-- Motif (obligatoire pour blacklist) -->
          <div v-if="type === 'blacklist'" class="pb-8 pr-6 w-full">
            <label class="form-label">Motif de blocage <span class="text-red-500">*</span></label>
            <textarea
              v-model="form.reason"
              class="form-input"
              rows="3"
              placeholder="Ex: Menaces répétées, harcèlement..."
              :class="{ 'border-red-500': errors.reason }"
            />
            <div v-if="errors.reason" class="form-error">{{ errors.reason }}</div>
          </div>

          <!-- Date d'expiration (blacklist uniquement) -->
          <div v-if="type === 'blacklist'" class="pb-8 pr-6 w-full lg:w-1/2">
            <label class="form-label">Date d'expiration (optionnel)</label>
            <input v-model="form.expires_at" type="datetime-local" class="form-input" />
            <p class="text-xs text-gray-500 mt-1">Laisser vide pour un blocage permanent</p>
          </div>

          <!-- Actif -->
          <div class="pb-8 pr-6 w-full lg:w-1/2 flex items-center gap-3 mt-4">
            <input id="is_active" v-model="form.is_active" type="checkbox" class="w-4 h-4" />
            <label for="is_active" class="form-label mb-0">Actif dès la création</label>
          </div>

        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <Link :href="cancelUrl" class="btn-white mr-3">Annuler</Link>
          <button type="submit" class="btn-indigo" :disabled="sending">
            {{ sending ? 'Enregistrement...' : 'Enregistrer' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import { Link, Head, router } from '@inertiajs/vue3'

const BASE = '/dashboard/settings/phone-lists'

export default {
  layout: Layout,
  components: { Link, Head },
  props: {
    title: String,
    type: String,
    departments: Array,
    errors: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      sending: false,
      form: {
        phone_number:  '',
        type:          this.type,
        label:         '',
        department_id: null,
        reason:        '',
        is_active:     true,
        expires_at:    '',
      },
    }
  },
  computed: {
    cancelUrl() {
      return this.type === 'whitelist' ? `${BASE}/whitelist` : `${BASE}/blacklist`
    },
  },
  methods: {
    store() {
      this.sending = true
      router.post(BASE, this.form, {
        onFinish: () => { this.sending = false },
      })
    },
  },
}
</script>
